import * as React from "react"

import { cn } from "@/components/utils/utils"

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, hasError = false, readOnly, ...props }, ref) => {
    return (
      <textarea
        readOnly={readOnly}
        className={cn(
          "flex min-h-[80px] w-full rounded-md border bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          hasError ? "border-yellow-400" : "border-input",
          // Sola lettura: nessun box/bordo, il campo si legge come testo semplice.
          readOnly && "border-transparent bg-transparent px-0 shadow-none cursor-default focus-visible:ring-0 resize-none",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
